import React from 'react';
import { GridJustification } from '@material-ui/core/Grid';
import Container from './Container';
import ContainerItem from './ContainerItem';

const getGridItemSize = (base: number, total: number) => {
  return Math.round(base / total);
};

interface Props {
  baseXs?: number;
  baseSm?: number;
  baseMd?: number;
  baseLg?: number;
  containerClassName?: string;
  itemClassName?: string;
  justify?: GridJustification;
  alignItems?: AlignSetting;
  noPadding?: boolean;
}

const BasicGrid: React.FC<Props> = ({
  children,
  itemClassName,
  containerClassName,
  baseXs = 12,
  baseSm = 12,
  baseMd = 6,
  baseLg = 4,
  justify = 'center',
  alignItems = 'center',
  noPadding = false,
}) => {
  return (
    <Container justify={justify} alignItems={alignItems} className={containerClassName}>
      {React.Children.map(children, (child) => (
        <ContainerItem
          xs={getGridItemSize(baseXs, React.Children.count(children))}
          sm={getGridItemSize(baseSm, React.Children.count(children))}
          md={getGridItemSize(baseMd, React.Children.count(children))}
          lg={getGridItemSize(baseLg, React.Children.count(children))}
          className={itemClassName}
          noPadding={noPadding}
        >
          {child}
        </ContainerItem>
      ))}
    </Container>
  );
};

export default BasicGrid;
